import * as React from "react";
import { styles } from "./ProductsTable.styles";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { findCategoryByName, findProductByName } from "../../views/productOverview/ProductHelper";
import { dateFormat } from "../../../utilities/dateTimeUtils";
import { ccyFormat } from "../../../utilities/PriceUtils";
import { requestProducts } from "../../../stores/products/ProductsAction";
import { KaikoDetailsComponent } from "./KaikoDetailsComponent";

export interface IProductsTableProps extends WithStyles<typeof styles> {
    tableItems: any;
}

const ProductsTablePure: React.FunctionComponent<IProductsTableProps> = ({classes, tableItems}: IProductsTableProps) => {

    const {t} = useTranslation();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(requestProducts());
        // eslint-disable-next-line
    }, []);

    const productsInfo = useSelector((state) => state.products);

    return <TableContainer className={classes.bottomMargin}>
        <Table className={classes.table} aria-label="spanning table">
            <TableHead className={classes.cellHead}>
                <TableRow>
                    <TableCell align="left">{t("orderDetails.position")}</TableCell>
                    <TableCell align="left">Product Category</TableCell>
                    <TableCell align="left">{t("general.product")}</TableCell>
                    <TableCell align="left">{t("orderDetails.timeRange")}</TableCell>
                    <TableCell align="right">{t("general.price")}</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {tableItems.map((item, itemIndex) => {
                    const product = findProductByName(productsInfo?.products, item.product);

                    return (
                        <TableRow key={itemIndex}>
                            <TableCell align="center" scope="row">{itemIndex + 1}</TableCell>
                            <TableCell
                                align="left">{findCategoryByName(productsInfo?.categories, product?.category)?.name}</TableCell>
                            <TableCell align="left">{product?.name}  {item.filterableProductParameters ? <KaikoDetailsComponent dates={[dateFormat(item.from.toString()), dateFormat(item.to.toString())]} exchanges={item.filterableProductParameters.levelOne} currencies={item.filterableProductParameters.levelTwo} /> : ""}</TableCell>
                            <TableCell
                                align="left">{dateFormat(item.from.toString())}<br></br>{dateFormat(item.to.toString())}
                            </TableCell>
                            <TableCell align="right">{ccyFormat(item.price)}</TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    </TableContainer>;
};

export const ProductsTable = withStyles(styles)(ProductsTablePure);
